import React, { useState, useEffect } from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import { Archive, ArrowReturnLeft, Book, Boxes, BoxSeam, CashStack, ClipboardData, JournalText, PersonBoundingBox, Shop, Speedometer2  } from 'react-bootstrap-icons';
import logo from './img/icon.png'
import './App.css';

function Menu({ handleSelectSection, section }) {

  return (
    <>
      <Container>
        <Row>
          <Col md={ 12 }>
            
            <div align="center">
              <div><img src={ logo } className="logo-menu" /></div>
              <div className="logo-title"> Inventario </div>
            </div>
            <hr/>

            <div className="menu-config">
              
              <br/>
              <div className="category-menu">Operación</div>
              <Container className="no-padding ">
                
                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'dashboard' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <Speedometer2 className={ section == 'dashboard' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'dashboard' ? "menu-item menu-item-active" : "menu-item" }>Dashboard</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'library' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <Book className={ section == 'library' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'library' ? "menu-item menu-item-active" : "menu-item" }>Libreria</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'shopping' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <Shop className={ section == 'shopping' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'shopping' ? "menu-item menu-item-active" : "menu-item" }>Compras</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'remision' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <Boxes className={ section == 'remision' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'remision' ? "menu-item menu-item-active" : "menu-item" }>Remisión de Ingreso</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'sales' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <CashStack className={ section == 'sales' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'sales' ? "menu-item menu-item-active" : "menu-item" }>Ventas</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'return' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <ArrowReturnLeft className={ section == 'return' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'return' ? "menu-item menu-item-active" : "menu-item" }>Devoluciones</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'reportes' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <ClipboardData className={ section == 'reportes' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'reportes' ? "menu-item menu-item-active" : "menu-item" }>Reporte</div>
                  </Col>
                </Row>

              </Container>

              <br/>
              <div className="category-menu">Configuración</div>
              <Container className="no-padding ">
                
                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'proveedores' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <BoxSeam className={ section == 'proveedores' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'proveedores' ? "menu-item menu-item-active" : "menu-item" }>Proveedores</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'editoriales' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <JournalText className={ section == 'editoriales' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'editoriales' ? "menu-item menu-item-active" : "menu-item" }>Editoriales</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'almacenes' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <Archive className={ section == 'almacenes' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'almacenes' ? "menu-item menu-item-active" : "menu-item" }>Almacenes</div>
                  </Col>
                </Row>

                <Row className="no-padding align-items-center" onClick={ () => handleSelectSection( 'clientes' ) }>
                  <Col md={ 'auto' } className="no-padding">
                    <div className="menu-bar"> <PersonBoundingBox className={ section == 'clientes' ? "menu-icon menu-icon-active" : "menu-icon" } /></div>
                  </Col>
                  <Col className="no-padding">
                    <div className={ section == 'clientes' ? "menu-item menu-item-active" : "menu-item" }>Clientes</div>
                  </Col>
                </Row>

              </Container>
              
              <div align="center">
                <div className="footer-menu">
                  <div>Copyright © 2024</div>
                  <div>Todos los Derechos Reservados</div>
                </div>
              </div>
            </div>
            
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Menu;
